module.exports = __webpack_public_path__ + "img/home-part-c.ac30c2ef.png";